import $ from 'jquery';
import LOGGER from '@component/common/src/util/Logger';
import PageApp from 'pageApp';
import ExpSdk from '@component/experiment/src/js/ExperimentationSDK';
import Util from './util/Util';
import ProsZones from './util/ProsZones';
import Carousel from './components/Carousel';
import ContentCarousel from './components/ContentCarousel';
import Grid from './components/Grid';
import ContentGrid from './components/ContentGrid';
import ContentWebDemoGrid from './components/ContentWebDemoGrid';
import Config from './util/Config';
import Recommendation from './recommendation/Recommendation';
import ProsEvents from './util/ProsEvents';
import ThumbnailCollection from './data/ThumbnailCollection';
import RecommendationStore from './store/RecommendationStore';
import ThumbnailModel from './data/ThumbnailModel';
import Context from './util/Context';
import List from './data/List';

const PageAppChannel = PageApp.channel;

const ProsApp = {


  /**
   *
   * @param _recommendationConfig = {
   *      requester:'MCOM-NAVAPP' or 'MCOM-MMEW'
   *      maxRecommendations:15/25/75
   *      zone:"PDP_ZONE_A|PDP_ZONE_B",
   *      productId:"22805",
   *      categoryId:"7919"
   * }
   *
   *@param properties = {
   *  fccFallbackEnabled :  Whether it should fallback to FCC or not (default is true)
   * }
   * @returns {ProsFactory}
   */
  getRecommendations(_recommendationConfig, properties, element) {
    try {
      if (!_recommendationConfig || !_recommendationConfig.zone) {
        LOGGER.error('Pros-factory ProsApp.js getRecommendations(opts) zone is missing in passed config', _recommendationConfig);
        return this;
      }

      const recommendationConfig = Config.recommendationConfig(_recommendationConfig, properties);

      if (properties && !properties.mltStitches && RecommendationStore.dateAvailable(recommendationConfig.config)) {
        return this;
      }

      Recommendation.getRecommendations(recommendationConfig)
        .then((json) => {
          const status = RecommendationStore.store(_recommendationConfig, json);
          if (!status) {
            $(element).hide();
            this.triggerFailure(_recommendationConfig);
          }
        }).catch((error) => {
          $(element).hide();
          this.triggerFailure(error.config);
        });
    } catch (e) {
      // wrapping public method, so it won't affect page in exception
      LOGGER.error('Pros-factory ProsApp.js getRecommendations got error : ', e);
    }

    return this;
  },

  triggerFailure(opts) {
    if (!opts) return;
    PageAppChannel.trigger('pros-carousel-render-failed', opts);
    const { requester, zone } = opts;
    if (requester && zone) {
      zone.split('|').forEach((_zone) => {
        PageAppChannel.trigger(Util.failureEvent({ requester, zone: _zone }), opts);
      });
    }
  },

  renderPanel({
    config, properties, json, workflow,
  }) {
    const thumbnailCollection = ThumbnailCollection;
    const thumbnailModel = ThumbnailModel;
    ThumbnailModel.contextParams = Context.generateContextParams().join('&');
    ThumbnailModel.hpZoneFlag = !!(config.zone && config.zone.indexOf('HP_ZONE') !== -1);
    const prosContentEnabledForZone = (properties.prosContentEnabled && json.content) || false;
    const prosCollectionEnabledForZone = (properties.prosCollectionsEnabled && json.content && json.content.isCollection) || false;
    const pageAppProperties = PageApp.getMeta('properties');

    if (!prosContentEnabledForZone && !prosCollectionEnabledForZone) {
      $(config.element).addClass('regular-pros-zone');
    }

    /* eslint-disable no-param-reassign */
    const GridClass = (config.viewType === 'grid') ? Grid : null;
    let PanelClass = GridClass;
    if (!PanelClass) {
      if (prosCollectionEnabledForZone) {
        ExpSdk.isRecipeSelected('341-21').always((response) => {
          if (response) {
            PanelClass = ContentWebDemoGrid;
          } else {
            PanelClass = ContentGrid;
          }
        });
        const contentHeader = json.content.contentHeader;
        // 2*3 grid
        config.pageSize = 6;
        config.minimumProductsToDisplay = 6;

        json.content.contentExperiment = 'TREAT1';
        json.content.contentTitle = {
          short: contentHeader,
          long: 'Inspired by you',
        };
      } else if (prosContentEnabledForZone) {
        PanelClass = ContentCarousel;

        // 2 products/page
        if (pageAppProperties.dbedDomSizeReductionEnabled) {
          config.pageSize = 2;
          properties.dbedDomSizeReductionEnabled = true;
        } else {
          config.pageSize = 1000;
        }

        config.minimumProductsToDisplay = 2;

        json.content.contentExperiment = 'TREAT1';
      } else {
        if (pageAppProperties && pageAppProperties.astraDrivenProsHeaderEnabled && config.zone === ProsZones.HOME_PAGE.HP_ZONE_E) {
          json.headerText = $(config.element).attr('data-header') ? $(config.element).attr('data-header') : json.headerText;
        }
        PanelClass = Carousel;
      }
    }
    /* eslint-disable no-param-reassign */

    const Panel = new PanelClass({
      el: config.element,
      config,
      properties,
      json,
      thumbnailCollection,
      thumbnailModel,
    });

    Panel.render();

    if (properties.mltStitches || properties.mltBagUnavailable) {
      RecommendationStore.clear(workflow);
    }
  },
  /**
   *
   * @param _panelConfig = {
   *          zone: "PDP_ZONE_A",
                element: "#prosPanel",
                orientation:"horizontal"/"vertical"
   * }
   * @param _properties={}
   * @returns {ProsFactory}
   */
  createPanel(_panelConfig, _properties) {
    try {
      if (!_panelConfig || !_panelConfig.zone || _panelConfig.zone.indexOf('|') !== -1 || !_panelConfig.element) {
        LOGGER.log('Pros-factory ProsApp.js zone and element parameters are mandatory in panelConfig.', _panelConfig);
        return this;
      }
      const { config, properties } = Config.panelConfig(_panelConfig, _properties);
      const workflow = RecommendationStore.getWorkflow(config, config.zone);

      const json = RecommendationStore.get(workflow);

      if (json) {
        this.renderPanel({
          config, properties, json, workflow,
        });
      } else {
        // async: data may still not loaded
        PageAppChannel.once(`${workflow}${ProsEvents.dataAvailable}`, (zoneJson) => {
          this.renderPanel({
            config, properties, json: zoneJson, workflow,
          });
        });
      }
    } catch (e) {
      // wrapping public method, so it won't affect page in exception
      LOGGER.error('Pros-factory ProsApp.js createPanel got error : ', e);
    }
    return this;
  },

  getHeartingListHistory() {
    const pageAppProperties = PageApp.getMeta('properties');

    if (!Util.internationalOrRegistryMode() &&
      !ProsApp.productFromLeastFetched &&
      pageAppProperties &&
      pageAppProperties.prosZonesAddToListEnabled) {
      ProsApp.productFromLeastFetched = true;
      List.getAllProductFromList();
    }
  },

  prosPanelOptionsSetup($element, configuration, ksProperties) {
    const {
      productIds,
      maxrecs: maxRecommendations,
      context: zone,
      fccFallbackEnabled,
      fccSortOrder,
      orientation,
      autoScrollTime,
      viewType,
      noDefaultRecs,
      pagesize: pageSize,
      properties,
    } = $element.data();

    let {
      productid: productId,
      categoryid: categoryId,
      uniqueId,
    } = $element.data();

    if (configuration.productId) {
      // eslint-disable-next-line prefer-destructuring
      productId = configuration.productId;
    }
    if (configuration.categoryId) {
      // eslint-disable-next-line prefer-destructuring
      categoryId = configuration.categoryId;
    }
    if (configuration.uniqueId) {
      // eslint-disable-next-line prefer-destructuring
      uniqueId = configuration.uniqueId;
    }

    const panelOptions = {
      zone,
      recommendationConfig: {
        maxRecommendations,
        productId,
        categoryId,
        productIds,
        noDefaultRecs, // eslint-disable-line no-undef
      },
      panelConfig: Object.assign({}, configuration, {
        element: $element,
        orientation,
        autoScrollTime,
        viewType,
        uniqueId,
        pageSize,
      }),
      properties: Object.assign({}, {
        ...ksProperties,
        fccFallbackEnabled,
        fccSortOrder,
      }, configuration.customProperties, properties),
    };
    if (configuration.freeShippingThresholdReminderAmount) {
      Object.assign(panelOptions.recommendationConfig, {
        freeShippingThresholdReminderAmount: configuration.freeShippingThresholdReminderAmount,
      });
    }
    if (configuration.recentlyViewedItems) {
      Object.assign(panelOptions.recommendationConfig, {
        recentlyViewedItems: configuration.recentlyViewedItems,
      });
    }
    return panelOptions;
  },
};

export default ProsApp;
